// extracted by mini-css-extract-plugin
export default {"column__text":"styles_column__text__frX1f","column__text-name":"styles_column__text-name__kRYWk"};